import { ApolloLink } from '@apollo/client';
import { getSharedUXPLink } from './UXPLink';

/**
 * Adds client and host app information to request headers for UXP environments
 */
export default new ApolloLink((operation, forward) => {
  const uxpLink = typeof window !== 'undefined' ? getSharedUXPLink() : null;

  if (!uxpLink) {
    return forward(operation);
  }

  const clientInfo = uxpLink.getClientIdentifier();
  const hostInfo = uxpLink.getHostInfo();

  const headers: Record<string, string> = {
    ...operation?.getContext()?.headers,
  };

  if (hostInfo) {
    const hostAppName = hostInfo.name?.toLowerCase() || 'unknown';
    const hostAppVersion = hostInfo.version || 'unknown';
    const hostApp = `${hostAppName}/${hostAppVersion}`;

    headers['x-frameio-client'] = `${clientInfo.client}/${hostApp}`;
  }

  operation.setContext({ headers });

  return forward(operation);
});
